import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fromVbnS02'
})
export class FromVbnS02Pipe implements PipeTransform {

  transform(value: string): number {
    if (!value) {
      return null;
    }

    var vbnDescription = value
      .replace('cm', '')
      .replace(' ', '')
      .trim();

    if (value == '') {
      return null;
    }

    if (value.indexOf('-') >= 0) {
      var parts = value.split('-');
      vbnDescription = parts[0];
    }

    return Number(vbnDescription);
  }
}
